import React from "react";
import Css from "./JavaScript.module.css";
import { Link } from "react-router-dom";
import NativeImage from "../PackageImage/NativeImage";
const JavaScript = () => {
  const products = [
    {
      id: 1,
      title: "Website CellOn",
      FrameWork: "JavaScript",
      paragraph: "Simple project By using Native",
      span: "Responsive",
      Preview: "https://mohamed-adel0.github.io/CellOn/",
      GitHub: "https://github.com/Mohamed-Adel0/CellOn",
      image: NativeImage.CellOn,
    },
    {
      id: 2,
      title: "Website ShopRoom",
      FrameWork: "JavaScript",
      paragraph:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolores dignissimos est.",
      span: "Responsive 80%",
      Preview: "https://mohamed-adel0.github.io/ShopRoom/",
      GitHub: "https://github.com/Mohamed-Adel0/ShopRoom",
      image: NativeImage.ShopRoom,
    },
    {
      id: 3,
      title: "Website RoyleHotel",
      FrameWork: "JavaScript",
      paragraph: "Project talking about Hotel",
      span: "Responsive 80%",
      Preview: "https://mohamed-adel0.github.io/Royal-Hotel/",
      GitHub: "https://github.com/Mohamed-Adel0/Royal-Hotel",
      image: NativeImage.RoyleHotel,
    },

    {
      id: 4,
      title: "Website Shopping",
      FrameWork: "JavaScript",
      paragraph:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolores dignissimos est dolor beatae qui cupiditate.",
      span: "Not Responsive",
      Preview: "https://mohamed-adel0.github.io/Shopping/",
      GitHub: "https://github.com/Mohamed-Adel0/Shopping",
      image: NativeImage.Shopping,
    },
  ];
  return (
    <div>
      <div className={Css.container}>
        {products?.map((r) => (
          <div className={Css.cards} key={r.id}>
            <div className={Css.card}>
              <div className={Css.img}>
                <Link to={r.Preview} target="_blank">
                  <img src={r.image} alt="" />
                </Link>
              </div>
              <div className={Css.text}>
                <h2>
                  {r.title} <span>{r.FrameWork}</span>
                </h2>
                <p>
                  {r.paragraph} <span>{r.span}</span>
                </p>
                <div className={Css.src}>
                  <Link target="_blank" to={r.Preview}>
                    Preview
                  </Link>
                  <Link target="_blank" to={r.GitHub}>
                    GitHub
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JavaScript;
